import React from "react";
import {
    Box,
    Grid,
    Typography,
    Paper,
    useTheme,
    useMediaQuery,
} from "@mui/material";
import BookSessionButton from "./BookSessionButton";

const sessionPoints = [
    {
        title: "A gentle check-in:",
        text:
            "I’ll ask a few simple questions to get to know you, understand where you are now, and clarify your goals and aspirations.",
    },
    {
        title: "Quick clarity, real value:",
        text:
            "While this isn’t a full session, many people experience breakthroughs and leave with practical insight—whether we work together or not.",
    },
    {
        title: "If it feels aligned:",
        text:
            "I’ll briefly share how I support clients and recommend the service or package that best fits your needs.",
    },
    {
        title: "Ask me anything:",
        text:
            "You’ll have space to ask any questions about me, my approach, or how Positive Psychology can support you.",
    },
    {
        title: "Zero pressure, ever:",
        text:
            "If it’s not a fit, that’s perfectly fine. I won’t sell to you or ask you to decide on the call.",
    },
    {
        title: "Your pace matters:",
        text:
            "I’ll encourage you to take your time, reflect on our conversation, and choose next steps that feel right for you.",
    },
];

export default function WhatToExpectFromSession() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Box
            sx={{
                py: { xs: 3, sm: 6 },
                backgroundColor: "#ffffffff",
                px: { xs: 0, sm: 0 }, // No left padding on phone
            }}
        >
            <Grid
                container
                spacing={isMobile ? 2 : 4}
                justifyContent="center"
                alignItems="flex-start"
                sx={{
                    maxWidth: "80%",
                    margin: "0 auto",
                    flexDirection: { xs: "column", sm: "row" },
                }}
            >
                <Grid item xs={12} sm={5}>
                    <Paper
                        elevation={2}
                        sx={{
                            overflow: "hidden",
                            borderRadius: 2,
                            mb: { xs: 2, sm: 0 },
                        }}
                    >
                        <Box
                            component="img"
                            src="/assets/sarah581.jpg"
                            alt="Sarah"
                            width="100%"
                            sx={{
                                display: "block",
                                height: { xs: 180, sm: "auto" },
                                objectFit: "cover",
                            }}
                            loading="lazy"
                        />
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={7}>
                    <Box>
                        <Typography
                            variant={isMobile ? "h5" : "h4"}
                            component="h2"
                            fontWeight={700}
                            gutterBottom
                            sx={{  }}
                        >
                            What to expect when you join me
                        </Typography>
                        <Typography
                            variant={isMobile ? "body1" : "h5"}
                            component="h3"
                            fontWeight={700}
                            gutterBottom
                            sx={{  }}
                        >
                            for your FREE Positive Psychology Session:
                        </Typography>
                        <Box sx={{ mt: 3 }}>
                            {sessionPoints.map((point, idx) => (
                                <Box key={idx} sx={{ mb: 2 }}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            color: "rgba(1,1,1,1)",
                                            fontSize: { xs: "1rem", sm: "1.1rem" },
                                        }}
                                    >
                                        <strong>{point.title}</strong> {point.text}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                        <Box sx={{ mt: 2 }}>
                            <BookSessionButton fullWidth={isMobile} />
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
